import { useCallback } from 'react';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { useCurrentUIMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { useViewUpdateState, useViewColumns, useNumberOfFrozenColumns, useCardProperties, useCurrentView, useFiltersForNewViews, useQuickFilterPropertyNamesState } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { useFilterGroups, useHiddenFilter } from 'framework-listing-lib/hooks/useListingLibFilters';
import useQuickFilters from 'framework-listing-lib/hooks/useQuickFilters';
import { buildViewUpdate, getViewWithNewFilters } from '../utils/mapper';
export default function useViewForm() {
  const hiddenFilter = useHiddenFilter();
  const {
    filters
  } = useCrmObjectTypeListingFilters();
  const objectType = useObjectTypeId();
  const [viewUpdateState] = useViewUpdateState();
  const columns = useViewColumns();
  const numberOfFrozenColumns = useNumberOfFrozenColumns();
  const currentUIMode = useCurrentUIMode();
  const filterGroups = useFilterGroups();
  const quickFilters = useQuickFilters();
  const cardProperties = useCardProperties();
  const currentView = useCurrentView();
  const filtersForNewViews = useFiltersForNewViews();
  const quickFilterPropertyNames = useQuickFilterPropertyNamesState();
  return useCallback(type => {
    let viewUpdate = buildViewUpdate({
      cardProperties,
      columns,
      currentUIMode,
      filterGroups,
      hiddenFilter,
      numberOfFrozenColumns,
      objectType,
      quickFilters,
      quickFilterPropertyNames,
      sort: filters.sort,
      view: type === 'UPDATE' ? currentView || undefined : undefined,
      viewUpdateState
    });
    if (type === 'CLONE_WITH_CHANGES') {
      var _currentView$name;
      viewUpdate.name = (_currentView$name = currentView === null || currentView === void 0 ? void 0 : currentView.name) !== null && _currentView$name !== void 0 ? _currentView$name : '';
    }
    if (type === 'CREATE_NEW') {
      viewUpdate = getViewWithNewFilters({
        filtersForNewViews,
        viewUpdate
      });
    }
    return viewUpdate;
  }, [cardProperties, columns, currentUIMode, currentView, filterGroups, filters.sort, filtersForNewViews, hiddenFilter, numberOfFrozenColumns, objectType, quickFilterPropertyNames, quickFilters, viewUpdateState]);
}